// extracted by mini-css-extract-plugin
export default {"FormControl":"get-project-items-block-module__FormControl--kBmEZ","Box":"get-project-items-block-module__Box--_XOZU"};